// extracted by mini-css-extract-plugin
module.exports = {"product-card":"centeredlogo_product-card__7K4Tx","container":"centeredlogo_container__9Ns62","logo":"centeredlogo_logo__jSB_V","logo__main":"centeredlogo_logo__main__KVDk0"};